import api from "../../api/index";

const getDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch`;
const startDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch/start`;
const completeDispatch = `${process.env.VUE_APP_BASE_URI}/enterprise/dispatch/complete`;
const getDispatchByTrackingId = `${process.env.VUE_APP_BASE_URI}/enterprise/trackDispatch`;
const trackDispatchByDevice = `${process.env.VUE_APP_BASE_URI}/enterprise/trackDispatchDevice`;
const searchContact = `${process.env.VUE_APP_BASE_URI}/enterprise/contact`;

const getDefaultState = () => {
  return {
    dispatchRecords: [],
    singleDispatch: [],
    dispatchByTrackId: [],
    dispatchByDevice: [],
    searchContact: [],
  };
};

const state = getDefaultState();

const getters = {
  dispatchRecords: (state) => state.dispatchRecords,
  singleDispatch: (state) => state.singleDispatch,
  dispatchByTrackId: (state) => state.dispatchByTrackId,
  dispatchByDevice: (state) => state.dispatchByDevice,
  searchContact: (state) => state.searchContact,
};

const actions = {
  async getDispatchRecords({ commit }) {
    commit("getDispatchRecords_request");
    const res = await api.get(getDispatch);
    if (res.data.status === "success") {
      commit("getDispatchRecords_success", res.data.data);
    }
    return res;
  },
  async getDispatchRecordById({ commit }, id) {
    commit("getDispatchRecordById_request");
    const res = await api.get(`${getDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("getDispatchRecordById_success", res.data.data);
    }
    return res;
  },
  async trackDispatch({ commit }, id) {
    commit("trackDispatch_request");
    const res = await api.get(`${getDispatchByTrackingId}/${id}`);
    if (res.data.status === "success") {
      commit("trackDispatch_success", res.data.data);
    }
    return res;
  },
  async trackDispatchDevice({ commit }, { id, imei }) {
    commit("trackDispatchDevice_request");
    const res = await api.get(`${trackDispatchByDevice}/${id}/${imei}`);
    if (res.data.status === "success") {
      commit("trackDispatchDevice_success", res.data.data);
    }
    return res;
  },
  async searchContact({ commit }, text) {
    commit("searchContact_request");
    const res = await api.get(`${searchContact}/${text}`);
    if (res.data.status === "success") {
      commit("searchContact_success", res.data.data);
    }
    return res;
  },

  async createDispatch({ commit }, data) {
    commit("createDispatch_request");
    const res = await api.post(getDispatch, data);
    if (res.data.status === "success") {
      commit("createDispatch_success");
    }
    return res;
  },
  async startDispatch({ commit }, id) {
    commit("startDispatch_request");
    const res = await api.put(`${startDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("startDispatch_success");
    }
    return res;
  },
  async completeDispatch({ commit }, id) {
    commit("completeDispatch_request");
    const res = await api.put(`${completeDispatch}/${id}`);
    if (res.data.status === "success") {
      commit("completeDispatch_success");
    }
    return res;
  },
};

const mutations = {
  getDispatchRecords_request: (state) => (state.status = "loading"),
  getDispatchRecords_success: (state, dispatchRecords) => {
    (state.status = "success"), (state.dispatchRecords = dispatchRecords);
  },
  getDispatchRecordById_request: (state) => (state.status = "loading"),
  getDispatchRecordById_success: (state, singleDispatch) => {
    (state.status = "success"), (state.singleDispatch = singleDispatch);
  },
  trackDispatch_request: (state) => (state.status = "loading"),
  trackDispatch_success: (state, dispatchByTrackId) => {
    (state.status = "success"), (state.dispatchByTrackId = dispatchByTrackId);
  },
  trackDispatchDevice_request: (state) => (state.status = "loading"),
  trackDispatchDevice_success: (state, dispatchByDevice) => {
    (state.status = "success"), (state.dispatchByDevice = dispatchByDevice);
  },
  searchContact_request: (state) => (state.status = "loading"),
  searchContact_success: (state, searchContact) => {
    (state.status = "success"), (state.searchContact = searchContact);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
